import React, { useEffect, useRef, useState } from 'react';
import * as Yup from "yup";
import Breadcrumbs from '../../components/BreadCrumbs';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import InputField from '../../components/inputFields/InputField';
import { Form, Formik } from 'formik';
import Button from '../../components/buttons/Button';
import Dropdown from '../../components/inputFields/DropDown';
import { hoThyroidOptions } from '../../constants/h_o_thyroid_options';
import FormikDropdown from '../../components/inputFields/FormikDropDown';
import FormikMultiSelectDropdown from '../../components/inputFields/FormikMultiSelectDropdown';
import { getHudOintments, getHudTablets } from '../../services/hud/hud_medicines';
import { toast } from 'react-toastify';
import DoseTable from '../../components/Hud/DoseTable';
import { getHudDoctorView, patchHudPatientDoctorView } from '../../services/doctor/doctor_view';
import { formatDateTime } from '../../utils/FormatDateTime';
import CustomLoading from '../../components/customLoading/CustomLoading';
import ShowModal from '../../components/Hud/ShowModal';
import PatientPackageComment from '../HUD/patients/patient_package_comment';
import { addHudPatientPackageComment, getHudPatients, patchHudPatientsHistory, postMedicineChanges, updateHudPatientDoctorView } from '../../services/hud/hud_patients';
import LineChart from '../../components/LineChart';
import AddUpdateDose from '../HUD/patients/add_update_dose';
import partLogo from '../../assets/icons/part-logo.png';
import { pricesColorCoding } from '../../constants/prices_colors_coding';
import PatientMedicineView from '../HUD/patients/patient_medicine_view';
import { BiCheckCircle, BiCross, BiWindowClose } from 'react-icons/bi';
import { hudGetUserPhotosUrl } from '../../constants/apis/doctor_apis';
import PatientPhotoGalleryApiComponent from '../../components/PatientPhotoGalleryApiComponent';
import { getUserToken } from '../../utils/localStoarege';

function DoctorView() {
    const timerRef = useRef(null);
    const [loading, setLoading] = useState(true);
    const [loadingBg, setLoadingBg] = useState(false);
    const [patients, setPatients] = useState([]);
    const [selectedPatient, setSelectedPatient] = useState("Choose Patient");
    const [availableTablets, setAvailableTablets] = useState([]);
    const [availableOintments, setAvailableOintments] = useState([]);
    const [initialValues, setInitialValues] = useState({
        "patient_id": "",
        "full_name": "",
        "address": "",
        "dob": "",
        "age": "",
        "date": "",
        "gender": "",
        "phone_number": "",
        "system_code": "",
        "skin_type": "",
        "registration_date": "",
        "patient_history": {
            "patient_history_id": "",
            "rating": "",
            "duration": "",
            "activity": null,
            "auto_imm_dis": "",
            "thyroid": "",
            "jaundice": "",
            "fh_auto_imm_dis": "",
            "ophthalmological_problems": "",
            "hospitalization": "",
            "psychiatric_history": "",
            "keloidol_tendency": "",
            "epilepsy": "",
            "blood_group": "",
            "steroid_history": "",
            "antibodies_to_thyroid": "",
            "h_o_epilepsy": "",
            "fh_b_vitiligo": null,
            "h_o_thyroid": "",
            "hb_value": "",
            "tablets": [],
            "ointments": [],
        },
        "packages": [],
        "photo": null
    });

    const patientIdRef = useRef(initialValues.patient_id);


    const fetchPatientDetails = async (needLoading = true, needBypass = false) => {
        if (needLoading) {
            setLoading(true);
        } else {
            setLoadingBg(true);
        }
        try {
            let res = await getHudDoctorView();
            if (res.status === 200) {
                // Use ref to compare the current patient_id
                // if (res.data.patient_id !== patientIdRef.current || needBypass) {
                setInitialValues(res.data); // Update state
                patientIdRef.current = res.data.patient_id; // Update ref
                // }
                setLoading(false);
                setLoadingBg(false);
            } else {
                toast.error("Unable to fetch patient");
            }
        } catch (error) {
            console.error("Unable to fetch patient details:", error);
        }
    };

    const fetchPatients = async () => {
        try {
            let res = await getHudPatients("?page_size=50");
            if (res.status === 200) {
                setPatients(res.data.results);
            } else {
                toast.error("Unable to fetch patients list");
            }
        } catch (error) {
            console.error("Unable to fetch patients list:", error);
        }
    };

    const fetchTablets = async () => {
        try {
            let res = await getHudTablets();
            if (res.status === 200) {
                setAvailableTablets(res.data);
            } else {
                toast.error("Unable to fetch Medicines");
            }
        } catch (error) {
            console.error("Unable to fetch Medicines:", error);
        }
    };

    const fetchOintments = async () => {
        try {
            let res = await getHudOintments();
            if (res.status === 200) {
                setAvailableOintments(res.data);
            } else {
                toast.error("Unable to fetch Medicines");
            }
        } catch (error) {
            console.error("Unable to fetch Medicines:", error);
        }
    };

    const handleSubmitRating = async (values, { setSubmitting, resetForm }) => {
        try {
            const updatedRatings = initialValues.patient_history.rating.length !== 0 && Array.isArray(JSON.parse(initialValues.patient_history.rating)) && JSON.parse(initialValues.patient_history.rating).length > 0
                ? [...JSON.parse(initialValues.patient_history.rating), values.rating]
                : [parseInt(values.rating)];

            const response = await patchHudPatientsHistory(initialValues.patient_id, {
                patient_id: initialValues.patient_id,
                rating: JSON.stringify(updatedRatings),
            });

            if (response?.status === 200) {
                toast.success("Rating added successfully!");
                fetchPatientDetails();
                resetForm();
            } else {
                let errors = "Oops! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Oops! Something went wrong, please try again.";
            toast.error(errors);
        }
        setSubmitting(false);
    };
    const [submitting, submittingUpdate] = useState(false);

    const handleMedicinesUpdate = async (values) => {
        submittingUpdate(true);
        try {
            const response = await postMedicineChanges({
                medicines: [...values.tablets, ...values.ointments],
            }, initialValues.patient_id);

            if (response?.status === 200) {
                toast.success("Medicines updated successfully!");
            } else {
                let errors = "Oops! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Oops! Something went wrong, please try again.";
            toast.error(errors);
        }
        submittingUpdate(false);
    };

    const handleSubmitComment = async (packageId, values, { setSubmitting, resetForm }) => {
        try {
            const response = await addHudPatientPackageComment(packageId, values);
            if (response?.status === 201) {
                fetchPatientDetails();
                resetForm();
                toast.success("Comment added successfully!");
            } else {
                toast.error("Oops! Something went wrong, please try again.");
            }
        } catch (error) {
            let errorMessage =
                error?.response?.data?.error ||
                "Oops! Something went wrong, please try again.";
            toast.error(errorMessage);
        } finally {
            setSubmitting(false);
        }
    };


    const handlePatientChange = async (value) => {
        setLoading(true);
        try {
            let res = await updateHudPatientDoctorView(value);
            if (res.status === 200) {
                fetchPatientDetails();
                toast.success(`Patient activated on doctor's view`);
            } else {
                toast.error("Unable to change deoctor view");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error updating doctor view:", error);
        } finally {
            setLoading(false);
        }
    };

    // Function to start the timer automatically
    const startTimer = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current); // Clear existing timer, if any
            timerRef.current = null;
        }
        fetchPatientDetails(); // Initial fetch
        timerRef.current = setInterval(() => {
            fetchPatientDetails(false); // Periodic fetch
        }, 10000); // 10 seconds
    };

    // Function to stop the timer
    const stopTimer = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current); // Clear the interval
            timerRef.current = null;
        }
    };

    useEffect(() => {
        fetchTablets();
        fetchOintments();
        fetchPatients();

        // Start the timer automatically when the component mounts
        startTimer();

        // Stop the timer automatically when the component unmounts or the user leaves the page
        return () => {
            stopTimer();
        };
    }, []); // Empty dependency array ensures this runs only on mount and unmount

    const [isPackageCommentModalOpen, setIsPackageCommentModalOpen] = useState(false);
    const [openingPackage, setOpeningPackage] = useState({});
    const [modalIsOpenPackage, setIsOpenPackage] = useState(false);

    const [isRatingChartModalOpen, setIsRatingChartModalOpen] = useState(false);
    const [isMedicineModalOpen, setIsMedicineModalOpen] = useState(false);
    const [medicineModalOpenFor, setIsMedicineModalOpenFor] = useState("");

    // Open modal with the selected PDF ID
    const openPackageCommentModal = (item) => {
        setOpeningPackage(item);
        setIsPackageCommentModalOpen(true);
    };

    const openRatingChartModal = (item) => {
        setIsRatingChartModalOpen(item);
    };

    // Close modal
    const closePackageCommentModal = () => {
        setIsPackageCommentModalOpen(false);
        setOpeningPackage({});
    };

    const openMedicineModal = (modelFor) => {
        setIsMedicineModalOpen(true);
        setIsMedicineModalOpenFor(modelFor);
    };

    // Close modal
    const closeMedicineModal = () => {
        setIsMedicineModalOpen(false);
        setIsMedicineModalOpenFor("");
    };

    const closeRatingGraphModal = () => {
        setIsRatingChartModalOpen(false);
    };

    const openModalAddPackage = (item) => {
        setOpeningPackage(item);
        setIsOpenPackage(true);
    };

    const closeAddPackageModal = () => {
        setIsOpenPackage(false);
    };

    const handleCommentAdded = () => {
        closePackageCommentModal();
        fetchPatientDetails(false, true);
    }

    const handlePackageOperation = () => {
        closeAddPackageModal();
        fetchPatientDetails(true, true);
    };

    return (loading ? <CustomLoading /> : <>
        <div className="flex flex-row justify-between text-xs">
            <Breadcrumbs items={[
                { name: 'Home', link: "/doctor/home" },
                { name: 'Doctor\'s View' },
            ]} />
            {
                loadingBg ? <p className="text-primary font-bold">Syncing...</p> : <></>
            }
        </div>
        <div className="flex flex-row justify-between items-center">
            <div className="flex flex-row gap-2 my-2">
                <StyledHeadingText size={"text-md font-bold"} text={"Patient Details: "} />
                <StyledHeadingText size={"text-md font-bold"} TextColor="text-red-600" text={initialValues.full_name} />
                <StyledHeadingText size={"text-md font-bold"} text={" | "} />
                <StyledHeadingText size={"text-md font-bold"} text={"Registration Date: "} />
                <StyledHeadingText size={"text-md font-bold"} TextColor="text-red-600" text={formatDateTime(initialValues.registration_date)} />
            </div>
            <Dropdown
                placeholder={selectedPatient}
                options={patients.map((center) => ({
                    value: center.patient_id,
                    label: center.full_name,
                }))}
                needSearch
                onChange={(value) => handlePatientChange(value)}
            />
        </div>
        <Formik
            initialValues={{
                ...initialValues,
                antibodies_to_thyroid: initialValues.patient_history.antibodies_to_thyroid,
                h_o_epilepsy: initialValues.patient_history.h_o_epilepsy,
                h_o_thyroid: initialValues.patient_history.h_o_thyroid,
                tablets: initialValues.patient_history.tablets,
                ointments: initialValues.patient_history.ointments,
                rating: "",
                age_gen: `${initialValues.age} | ${initialValues.gender}`
            }}
            validationSchema={Yup.object({
                rating: Yup.string().required("Rating is required"),
            })}
            onSubmit={handleSubmitRating}
            enableReinitialize
        >
            {({ isSubmitting, setFieldValue, resetForm, values }) => (
                <Form>
                    <div className="flex flex-col lg:flex-row gap-4 w-full">
                        <div className="border rounded-md shadow-lg p-2 border-primary bg-white lg:max-w-min">
                            <div className="flex flex-row justify-between">
                                <PatientPhotoGalleryApiComponent imageToDisplay={initialValues.photo || partLogo} className='rounded-full aspect-square max-w-16 border border-primary' apiEndpoint={hudGetUserPhotosUrl + initialValues.patient_id + "/history/photos/?page_size=50"} token={getUserToken()} />
                                <InputField
                                    label="Age | Gen"
                                    name="age_gen"
                                    type="text"
                                    placeholder="XX"
                                    disable
                                />
                            </div>
                            <InputField
                                label="Address"
                                name="address"
                                type="text"
                                placeholder="User Address"
                                disable
                            />
                            <div className="flex flex-row gap-2">
                                <InputField
                                    label="Skin Type"
                                    name="skin_type"
                                    type="text"
                                    placeholder="V"
                                    disable
                                />
                                <InputField
                                    label="Phone Number"
                                    name="phone_number"
                                    type="text"
                                    placeholder="XXXXXXXXX"
                                    disable
                                />
                            </div>
                            <InputField
                                label="System Code"
                                name="system_code"
                                type="text"
                                placeholder="XXXXXXXXX"
                                disable
                            />
                            <div className="flex flex-row items-end">
                                <InputField
                                    label="Rating"
                                    name="rating"
                                    type="text"
                                    placeholder="4"
                                    required
                                />
                                <Button
                                    type="submit"
                                    className="text-white bg-secondary hover:bg-primary-dark font-sm text-xs px-8 py-2.5 text-center max-h-12 mb-1 mr-1"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? "Adding..." : "Add"}
                                </Button>
                                <div
                                    className="rounded text-white bg-primary hover:bg-primary-dark font-sm text-xs px-8 py-2.5 text-center max-h-12 mb-1 cursor-pointer"
                                    onClick={() => openRatingChartModal(true)}
                                >
                                    View
                                </div>
                            </div>
                        </div>
                        <div className="border rounded-md shadow-lg p-2 border-primary flex-1 bg-white">
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-8 gap-0.5 mt-2">
                                {[
                                    { label: "Duration", value: initialValues.patient_history.duration, },
                                    { label: "Activity (koebnerisation)", value: initialValues.patient_history.activity, },
                                    { label: "H/O auto immune diseases", value: initialValues.patient_history.auto_imm_dis, },
                                    { label: "Thyroid", value: initialValues.patient_history.thyroid, },
                                    { label: "H/O Jaundice", value: initialValues.patient_history.jaundice, },
                                    { label: "F/H (A) auto immune diseases", value: initialValues.patient_history.fh_auto_imm_dis, },
                                    { label: "F/H (B) vitiligo", value: initialValues.patient_history.fh_b_vitiligo, },
                                    { label: "Ophthalmological problems", value: initialValues.patient_history.ophthalmological_problems, },
                                    { label: "H/O hosptalisathion", value: initialValues.patient_history.hospitalization, },
                                    { label: "Psychiatric history", value: initialValues.patient_history.psychiatric_history, },
                                    { label: "Keloidol tendencey", value: initialValues.patient_history.keloidol_tendency, },
                                    { label: "Epilepsy", value: initialValues.patient_history.epilepsy, },
                                    { label: "Blood Group", value: initialValues.patient_history.blood_group, },
                                    { label: "H. B.", value: initialValues.patient_history.hb_value, },
                                    { label: "History of steroid", value: initialValues.patient_history.steroid_history, },
                                ].map((card, index) => (
                                    <div className="flex flex-col">
                                        <div className="flex flex-row justify-center items-center bg-primary opacity-55 text-[0.6rem] text-center text-white py-1 px-1 h-10">{card.label}</div>
                                        <div className="flex flex-row justify-center items-center text-red-500 font-extrabold text-center py-1 text-[0.6rem] px-1 h-10 border border-secondary">{card.value}</div>
                                    </div>
                                ))}
                            </div>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                <InputField
                                    label="Photo Date"
                                    name="photo_of_date"
                                    type="date"
                                    placeholder="V"
                                    disable
                                />
                                <FormikDropdown
                                    label="Antibodies to Thyroid"
                                    name="antibodies_to_thyroid"
                                    placeholder="Select"
                                    needSearch
                                    options={[
                                        { value: "Yes", label: "Yes" },
                                        { value: "No", label: "No" },
                                    ]}
                                    disabled
                                />
                                <FormikDropdown
                                    label="H/O Epilepsy"
                                    name="h_o_epilepsy"
                                    placeholder="Select"
                                    needSearch
                                    options={[
                                        { value: "Yes", label: "Yes" },
                                        { value: "No", label: "No" },
                                    ]}
                                    disabled
                                />
                            </div>
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                <div className="flex flex-row items-end">
                                    <div className="flex-1">
                                        <FormikMultiSelectDropdown
                                            label="Tablets"
                                            name="tablets"
                                            needSearch
                                            placeholder="Select Tablets"
                                            options={availableTablets.map((item) => ({
                                                value: item.medicine_id,
                                                label: item.name,
                                            }))}
                                        />
                                    </div>
                                    <div
                                        className="text-white bg-primary hover:bg-primary-dark font-sm text-xs px-8 py-2.5 text-center max-h-12 mb-2 rounded cursor-pointer"
                                        onClick={() => openMedicineModal("tablet")}
                                    >
                                        View
                                    </div>
                                </div>
                                <div className="flex flex-row items-end">
                                    <div className="flex-1">
                                        <FormikMultiSelectDropdown
                                            label="Ointments"
                                            name="ointments"
                                            needSearch
                                            placeholder="Select Ointments"
                                            options={availableOintments.map((item) => ({
                                                value: item.medicine_id,
                                                label: item.name,
                                            }))}
                                        />
                                    </div>
                                    <div
                                        className="text-white bg-primary hover:bg-primary-dark font-sm text-xs px-8 py-2.5 text-center max-h-12 mb-2 rounded cursor-pointer"
                                        onClick={() => openMedicineModal("ointment")}
                                    >
                                        View
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-row items-end">
                                <div className="flex-1">
                                    <FormikDropdown
                                        label="H/O Thyroid"
                                        name="h_o_thyroid"
                                        placeholder="Select"
                                        disabled
                                        options={hoThyroidOptions.map((item) => ({
                                            value: item,
                                            label: item,
                                        }))}
                                    />
                                </div>
                                <div
                                    type="submit"
                                    className="text-white bg-secondary hover:bg-primary-dark font-sm text-xs px-8 py-3 cursor-pointer text-center max-h-12 mb-2 mr-1 rounded"
                                    onClick={submitting ? null : () => handleMedicinesUpdate(values)}
                                >
                                    {submitting ? "Updating..." : "Update"}
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            )}
        </Formik >
        <div className="py-2">
            {initialValues.packages.map((data, index) => (
                <div className="flex flex-col border-y-2 border-primary mb-1 bg-white shadow-lg px-3 pb-2 overflow-x-auto">
                    <div className="flex flex-row pt-2 justify-start items-end gap-2 mb-2">
                        <div className="border rounded-md bg-gray-100 px-2 mb-0.5 py-2.5 text-xs flex flex-row items-center justify-start space-x-2 min-w-80">
                            <p className='text-red-600 font-bold'>{data.package_name}</p>
                            {/* <span> | Rem. Am.- {data.remaining_amount ? "₹ " + (data.remaining_amount / 1000) : ""}</span> */}
                            <p className="font-bold text-xs">Pkg. Color: {pricesColorCoding.find((e) => e.amount === data.amount)?.title ?? `₹${data.amount}`}</p>
                            <span className={`w-6 h-3 rounded-full border shadow ${pricesColorCoding.find((e) => e.amount === data.amount)?.bg ?? ""} ${pricesColorCoding.find((e) => e.amount === data.amount)?.color ? "" : "hidden"}`}></span>
                            <p className="font-bold text-xs">{pricesColorCoding.find((e) => e.amount === data.amount)?.short_hand ?? ""}</p>
                            <Button className={`${data.amount === 10000 && data.package_name.toUpperCase() === "FULL BODY" ? "hidden" : ""} ${data.approval_image ? "bg-green-500" : "bg-red-700"} rounded-full text-white text-xs`} onClick={data.approval_image ? () => { window.open(data.approval_image, "_blank"); } : null}>{data.approval_image ? <BiCheckCircle color="white" size={14} /> : <BiWindowClose color="white" size={14} />}</Button>
                        </div>

                        {/* <div className="border rounded-md bg-gray-100 px-2 items-center justify-center py-1.5 text-xs">
                            Package- <span className='text-red-600 font-bold'>{data.package_name}</span> | Date- {data.date.includes(" ") ? data.date.split(" ")[0] : data.date} | Amount- {data.amount ? "₹ " + (data.amount / 1000) : ""} | Rem. Am.- {data.remaining_amount ? "₹ " + (data.remaining_amount / 1000) : ""}
                        </div> */}
                        <Formik
                            initialValues={{
                                comment: data.last_package_comment ?? "",
                            }}
                            validationSchema={Yup.object({
                                comment: Yup.string().required("Please enter a comment"),
                            })}
                            onSubmit={(values, { setSubmitting, resetForm }) =>
                                handleSubmitComment(data.package_id, values, { setSubmitting, resetForm })
                            }
                            enableReinitialize
                            className="w-full"
                        >
                            {({ isSubmitting }) => (
                                <Form className='w-full'>
                                    <div className="flex flex-row items-end justify-end">
                                        <InputField
                                            name="comment"
                                            type="text"
                                            key={index}
                                            placeholder={"Write commente here..."}
                                            className={"text-red-600 flex-1 rounded"}
                                        />
                                        <Button
                                            type="submit"
                                            className="text-white bg-secondary hover:bg-primary-dark font-sm text-xs px-8 py-2.5 text-center max-h-12 mb-1 mr-0.5"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? "Adding..." : "Add"}
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                        <Button
                            className="text-white bg-primary hover:bg-primary-dark font-sm text-xs px-8 py-2.5 text-center max-h-12 mb-1"
                            onClick={() => openPackageCommentModal(data)}
                        >
                            View
                        </Button>
                    </div>
                    {
                        <DoseTable
                            data={data.doses}
                            packageId={data.package_id}
                            fetchData={() => fetchPatientDetails()}
                            needExtraOptions={false}
                        />
                    }
                    <Button
                        className="text-white bg-primary hover:bg-primary-dark font-sm text-xs px-8 py-1.5 text-center max-h-12 mt-2 max-w-40"
                        onClick={() => openModalAddPackage(data)}
                    >
                        Add Dose
                    </Button>
                </div>
            ))}
        </div>
        <ShowModal contentLabel={"Package Comment alert"} isOpen={isPackageCommentModalOpen} onRequestClose={closePackageCommentModal} componentToPass={<PatientPackageComment packageId={openingPackage.package_id} onAddNewComment={handleCommentAdded} packageComments={openingPackage.package_comments} />} />
        <ShowModal modalWidth={"50%"} contentLabel={"Ratings alert"} isOpen={isRatingChartModalOpen} onRequestClose={closeRatingGraphModal} componentToPass={<LineChart label={'Ratings'} dataPoints={initialValues.patient_history.rating.length !== 0 ? JSON.parse(initialValues.patient_history.rating) : []} />} />
        <ShowModal modalWidth={"50%"} contentLabel={"View Medcine alert"} isOpen={isMedicineModalOpen} onRequestClose={closeMedicineModal} componentToPass={<PatientMedicineView openedFor={medicineModalOpenFor} patientId={initialValues.patient_id} />} />
        <ShowModal
            contentLabel={"Add dose alert"}
            isOpen={modalIsOpenPackage}
            modalWidth={"50%"}
            onRequestClose={closeAddPackageModal}
            componentToPass={
                <AddUpdateDose
                    packageId={openingPackage.package_id}
                    onDoseOperation={handlePackageOperation}
                />
            }
        />
    </>);
}

export default DoctorView;